/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function openAccordion(evt, name) {
  const accordionBody = document.getElementById(name);
  const iconPlus = evt.currentTarget.querySelector('.accordion-icon-plus');
  const iconMinus = evt.currentTarget.querySelector('.accordion-icon-minus');

  // Toggle the display of the clicked accordion body
  if (accordionBody.style.display === "block") {
    accordionBody.style.display = "none"; // Close if open
    iconPlus.classList.add("active"); // Show plus icon
    iconMinus.classList.remove("active"); // Hide minus icon
  } else {
    // Close all accordion bodies
    const allBodies = document.getElementsByClassName("accordion-body");
    const allIconsPlus = document.querySelectorAll(".accordion-icon-plus");
    const allIconsMinus = document.querySelectorAll(".accordion-icon-minus");
    for (let i = 0; i < allBodies.length; i++) {
      allBodies[i].style.display = "none";
      allIconsPlus[i].classList.add("active"); // Show all plus icons
      allIconsMinus[i].classList.remove("active"); // Hide all minus icons
    }

    // Remove active class from all heads
    const tablinks = document.getElementsByClassName("accordion-head");
    for (let i = 0; i < tablinks.length; i++) {
      tablinks[i].classList.remove("active");
    }

    // Open the clicked accordion body
    accordionBody.style.display = "block";
    evt.currentTarget.classList.add("active");
    iconPlus.classList.remove("active"); // Hide plus icon
    iconMinus.classList.add("active"); // Show minus icon
  }
}

// document.addEventListener("DOMContentLoaded", function() {
//   const deliveryInputs = document.querySelectorAll(".delivery-option-input")
//   let selectedOption 
//   const hiddenInput = document.getElementById("selectedDeliveryOption")

//   for (let i = 0; i < deliveryInputs[i]; i++) {
//     const deliveryInput = deliveryInputs[i]

//     console.log("input", deliveryInput)

//     deliveryInput.addEventListener("input", function() {
//       console.log("hello?")
//       selectedOption = deliveryInput.value
//       hiddenInput.value = selectedOption
//       console.log("so", selectedOption)
//     })
//   }
// })